<script>
import con from '@services/connection'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import Card from '@components/card-div'

export default {
  components: { Card },
  props: {
    /**
     * Percentual do efeito de loading.
     * 0: Enviando requisição ainda, buffer.
     */
    load: Number,
    loading: Boolean,
    status: String,
  },
  data() {
    return {}
  },
}
</script>

<template>
  <div v-if="loading" style="width: 100%;">
    <Card class="elevation-3" style="width: 100%;">
      <div class="d-flex align-items-center justify-content-center">
        <v-progress-linear
          :value="load"
          :buffer-value="0"
          :indeterminate="load == 0"
          :stream="true"
          striped
        ></v-progress-linear>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <p class="my-3"> {{ status }} </p>
      </div>
    </Card>
  </div>
</template>


